import { Box, Paper, styled } from '@mui/material';
import Grid from '@mui/material/Grid2';

const appBarHeight = 64;

export const RootDiv = styled('div')(({ _ }) => ({
  backgroundColor: '#212936',
  marginTop: -appBarHeight + 30,
  borderBottom: 1,
  height: '90vh',
}));

export const AppBarSpacer = styled(Box)(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

export const ViewportContainer = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  height: '95%',
  width: '100%',
}));

export const ToolAreaContainer = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  width: '100%',
}));

export const CaseInfoContainer = styled(Grid)(({ _ }) => ({
  maxHeight: '15vh',
  width: '100%',
}));

export const FeedbackContainer = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  maxHeight: '15vh',
  width: '100%',
}));

export const ReceivedAssignmentPaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(1),
  padding: theme.spacing(1),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
  width: '100%',
}));

export const PaperViewport = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
}));

export const PaperFeedback = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
  maxHeight: '100%',
  width: '100%',
}));

export const FeedbackContainerPrev = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  maxHeight: '100%',
  width: '100%',
}));

export const PaperViewportPrev = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
  height: '65vh',
  width: '100%',
}));

export const PaperFeedbackPrev = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
  maxHeight: '100%',
  width: '100%',
}));
